export default {
  state: {
    pix: {}
  },
  mutations: {
    setPix (state, pix) {
      state.pix = pix
    }
  },
  actions: {
    setPix ({ commit }, pix) {
      commit('setPix', pix)

      localStorage.setItem('pixPaymentInfo', JSON.stringify(pix))
    }
  },
  getters: {
    getPix: (state) => state.pix
  }
}
